import { render, staticRenderFns } from "./FullScreenImageModal.vue?vue&type=template&id=6c58fcf4&scoped=true&"
import script from "./FullScreenImageModal.vue?vue&type=script&lang=js&"
export * from "./FullScreenImageModal.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenImageModal.vue?vue&type=style&index=0&id=6c58fcf4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c58fcf4",
  null
  
)

export default component.exports